import { render, staticRenderFns } from "./UserRoleChanged.vue?vue&type=template&id=0a3612d2&scoped=true"
import script from "./UserRoleChanged.vue?vue&type=script&lang=js"
export * from "./UserRoleChanged.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a3612d2",
  null
  
)

export default component.exports